import { createStore } from 'vuex';

export default createStore({
    state () {
        return {
            token: null,
            authenticated: parseFloat(localStorage.authenticated),
            sessionTime: {
                time: 1 * 60 * 60,
                max: 1 * 60 * 60,
            },
            user: {},
            access: false,
        }
    },
    mutations: {
        setAuth(state, value) {
            state.authenticated = value;
        },
        setToken(state, value) {
            state.token = value;
        },
        setUser(state, value) {
            state.user = value;
        },
        setAccess(state, value) {
            state.access = value;
        },
    },
    getters: {
        getAuth: (state) => {
          return parseFloat(state.authenticated);
        },
        getUserAttribute: (state) => (name) => {
          return state.user[name];
        },
        getUser: (state) => {
          return state.user;
        },
        getAccess: (state) => {
          return state.access;
        },
        getSessionTime: (state) => {
          return state.sessionTime;
        },
    },
    actions: {
        // login({ commit }) {
        //     commit('setAuthenticated', true);
        //     localStorage.isAuthenticated = true;
        // },
        // logout({ commit }) {
        //     commit('setAuthenticated', false);
        //     commit('setUser', {});
        //     localStorage.isAuthenticated = false;
        // },
        // addHelperListElement({ commit }, payload) {
        //     commit('addHelperListElement', payload);
        //     commit('sortHelper', payload.name);
        // },
    }
})